import { useAppTranslation } from "@hooks/useAppTranslation";

import DButton from "@UI/components/Atoms/Button/DButton";

const VersionToastInfo = () => {
  const { t } = useAppTranslation();

  const handleRefresh = () => location.reload();

  return (
    <div className="d-flex d-flex-column d-align-center d-gap-8">
      <div>{t("common.app_outdated")}</div>
      <DButton onClick={handleRefresh} label={t("common.refresh")} />
    </div>
  );
};

export default VersionToastInfo;
